// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonIcon_button__30N53","background":"ButtonIcon_background__sC5Wz"};